import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { faTriangleExclamation, faXmark, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Location} from "@angular/common";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
@Component({
    selector: 'announcement-config',
    templateUrl: './announcement-config.component.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class AnnouncementConfigComponent implements OnInit {
  router = inject(Router)
  dashboard = 'instructor';
  route = inject(ActivatedRoute)
  msg = ''
  message_id = -1
  isEdit = false
  systemService = inject(SystemManagementService)
  _snackBar = inject(MatSnackBar)
  _location = inject(Location)
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }, {
    text: 'Announcements',
    route: 'dashboard/SystemManagement/Announcement/List'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if(params['message_id']) {
        this.isEdit = true
        this.msg = params['msg']
        this.message_id = params['message_id']
        this.dashboard = params['dashboard']
      }
    })
  }

  cancelMessage() {
    this.router.navigate(['dashboard/SystemManagement/Announcement/List'])
  }

  switchToInstructor(dashboard: string) {
    this.dashboard = dashboard
  }

  saveMessage() {
    if(!this.isEdit) {
      this.systemService.addAnnouncement(this.msg, this.dashboard).subscribe((response) => {
        if(response.success) {
          this._snackBar.open('Announcement successfully Added', 'Dismiss')
          this.cancelMessage()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
    else {
      this.systemService.editAnnouncement(this.msg, this.message_id).subscribe((response) => {
        if(response.success) {
          this._snackBar.open('Announcement successfully Edited', 'Dismiss')
          this.cancelMessage()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }
}
